import {useState} from 'react';
import { Box, Flex, Tooltip, Image} from "@chakra-ui/react";

import { validateUrlFormat } from '../../../global/helpers/global-helpers';

import '../../styles/vault.scss';
import { IoCalendarOutline, IoCheckmarkCircleOutline } from "react-icons/io5";
import LaunchdeckTag from '../../../global/components/helper-components/components/LaunchdeckTag';
import JoinRequestCardOptionsButton from './JoinRequestCardOptionsButton';
import { displayElapsedDurationSinceTimestamp } from '../../../global/helpers/time-format-helpers';

export default function JoinRequestCardDisplay({ dsrData, handleChangeUserActionRequired }) {
  const { dsrTitle, requestTimestamp, dsrId, audienceLogoCardDisplay} = dsrData || {};

  const [showOptionButton, setShowOptionButton] = useState(false)

  const renderAudienceLogo = () => {
    const { orgLogo, orgName } = audienceLogoCardDisplay || {};
    const isUrl = orgLogo ? validateUrlFormat(orgLogo) : false ;

    if (isUrl) {
      if (orgName) {
        return (
          <Box boxSize='2em' mr='0.5em'>
            <Tooltip label={orgName} fontSize='0.8em' fontWeight='400' placement="bottom" bg="#4A5568" rounded='0.25em'>
               <Box p='0.2em' rounded='0.25em' border='1px solid' borderColor='gray.200'>
                <Image maxH='2em' src={orgLogo} />
              </Box> 
            </Tooltip>
          </Box>
        )
      } else if (!orgName) {
        return (
          <Box mr='0.5em'>
          <Box p='0.2em' rounded='0.25em' border='1px solid' borderColor='gray.200'>
            <Image maxH={'2em'} src={orgLogo} />
          </Box>
        </Box>
        )
      }
     

    } else if (orgName) {
      return (
        <Flex className="status-tag__draft-container status-tag__text-light" mr='0.5em'>
          <Box >{orgName}</Box>
        </Flex>
      )
    } else return null;

  }

  return (
    <Flex className="card-display" 
    position='relative'
    onMouseOver={() => setShowOptionButton(true)}
    onMouseOut={() => setShowOptionButton(false)}
    >

      <Box className="card-content-stack">
        <Flex align='center' justify='space-between' w='100%'>
          <Box>{renderAudienceLogo()}</Box>
        </Flex>
         <Box opacity={showOptionButton ? '1.0' : '0'}>
            <JoinRequestCardOptionsButton
              dsrId={dsrId}
              dsrTitle={dsrTitle}
              handleChangeUserActionRequired={handleChangeUserActionRequired}
            />
          </Box>
      </Box>


      <Box w='100%'>
        <Box className="card-content-stack__column">
          <Box maxWidth={['60vw', '20vw']} className="dsr-title-display" title={dsrTitle || "-"}>
            {dsrTitle || "-"}
          </Box>

          <Flex className="stats-display">
            <Flex align='center' gap='0.25em'>
              <Box as={IoCalendarOutline} />
              <Box> Request sent:  {displayElapsedDurationSinceTimestamp(requestTimestamp)} </Box>
            </Flex>
          </Flex>

          <Flex className="stats-display">
          <Flex align='center' gap='0.25em'>
              <Box as={IoCheckmarkCircleOutline} />
              <Box> Pending approval</Box>
            </Flex>
            </Flex>

          <Flex mt='0.5em'>
            <LaunchdeckTag bg='brand.300' color='white' label='Join request' />
          </Flex>
        </Box>
      </Box>
    </Flex>
  )
}


